<template>
  <div class="mcontainer" v-if="$route.name === 'auth' || $route.name === 'authSlug'">
    <router-view />
  </div>
  <div class="mcontainer" v-else>
    <Header />
    <div class="mcontainer__content">
      <Nav class="desctop" />
      <div class="mcontainer__content-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/layouts/NavBlock.vue";
import Header from "@/components/layouts/HeaderBlock.vue";
export default {
  components: { Header, Nav },
}
</script>

<style lang="scss" scoped>
.mcontainer {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  &__content {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    overflow: auto;
    &-view {
      position: relative;
      z-index: 0;
      flex-grow: 1;
      width: 100%;
      height: 100%;
      background: #F5F5F5;
      overflow-y: auto;
      padding: 32px 50px 32px 40px;
      @media screen and (max-width: $tablet) {
        position: fixed;
        padding: 16px 12px;     
        height: calc(100% - 60px);   
        background: #fafafa;
        display: flex;
        flex-direction: column;
        align-items: stretch;
      }
    }
  }
}
.main-flex {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: stretch;
  position: relative;
}

.main {
  flex-grow: 1;
}

html,
body,
p {
  font-family: 'Roboto', sans-serif;
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  width: 6px;
  height: 0;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: #B247A7;
}
::-webkit-scrollbar:hover {
  background-color: gray;
}
::-webkit-scrollbar-button {
  background: #F8F8F8;
}

</style>
